import './view.sass';

import React from 'react';

import Tree from 'components/tracks-tree/tree/Tree';
import ShortEvents from 'components/tracks-tree/short-events/ShortEvents';

export default function View() {
  return (
    <div className='tracks-tree-view'>
      <Tree/>
      <ShortEvents/>
    </div>
  );
}
